<template>
    <div class="apaympro-footer animated fadeIn mb-5 mt-5">
        <div 
            class="text-primary font-15" 
            style="
                position: relative; 
                line-height: 1.7rem;
            "
        >
            Vous avez un souci ?  <br>
            <a 
                class="btn-link btn-whatsapp mt-3" 
                href="https://api.whatsapp.com/send/?phone=2250554175175&text&app_absent=0"
            > 
                <i class="fab fa-whatsapp"></i> Contactez le SAV sur WhatsApp 
                <br>
                au +225 05 54 175 175
            </a> 
        </div>

        <div class="mb-1">
            <img 
                class="mt-4" 
                alt="APAYM Cabine secured badge"
                src="../assets/Secured-by-apaym-pci-dss.png" 
                style="width: 210px;"
            />
        </div>
        <span 
            class="mt-2 mb-5 text-primary" 
            style="
                position: relative; 
                top: 10px; 
                margin-bottom: 20px;
            "
        >
            Version 1.0
        </span>
        <br><br>
    </div>
</template>

<script>

    export default {
        components: {
        },
        data() {
            return {
            }
        },
        methods: {
        },
        mounted(){
        },
    }
</script>